import React, { useState } from 'react';
import {
    YesNoSelectionPanelGroup,
    SelectionPanelGroupTheme,
    SelectionPanelGroupStyleMode,
    SelectionPanelCheckShape,
    SelectionPanelCheckStyle,
    SelectionPanelGroupLayoutStyle,
} from '@apply/components';
import { DemoExample } from '../../common/DemoLayout';

/** YesNoSelectionPanelGroup: a single-select Yes / No group bound to a boolean | undefined value. */
export const YesNoPanel: React.FC = () => {
    const [condensedValue, set_condensedValue] = useState<boolean | undefined>(true);
    const [horizontalValue, set_horizontalValue] = useState<boolean | undefined>(undefined);
    const [horizontalWrappedValue, set_horizontalWrappedValue] = useState<boolean | undefined>(false);

    return (
        <>
            <DemoExample label='Blue Theme (Condensed, Circle Fill, With Label)'>
                <YesNoSelectionPanelGroup
                    id='yesNoCondensedDemo'
                    value={condensedValue}
                    onChange={set_condensedValue}
                    theme={SelectionPanelGroupTheme.Blue}
                    styleMode={SelectionPanelGroupStyleMode.Condensed}
                    checkShape={SelectionPanelCheckShape.Circle}
                    checkStyle={SelectionPanelCheckStyle.Fill}
                    label='First Loan?'
                    showInfoIcon={true}
                    infoText='Is the property owned by the borrower?'
                />
            </DemoExample>
            <DemoExample label='Blue Theme (Condensed, Circle Fill, With Label, Horizontal)'>
                <YesNoSelectionPanelGroup
                    id='yesNoHorizontalDemo'
                    value={horizontalValue}
                    onChange={set_horizontalValue}
                    theme={SelectionPanelGroupTheme.Blue}
                    styleMode={SelectionPanelGroupStyleMode.Condensed}
                    checkShape={SelectionPanelCheckShape.Circle}
                    checkStyle={SelectionPanelCheckStyle.Fill}
                    label='First Loan?'
                    layoutStyle={SelectionPanelGroupLayoutStyle.Horizontal}
                    labelWidth='150px'
                />
            </DemoExample>
            <DemoExample label='Blue Theme (Condensed, Circle Fill, With Label, Horizontal, Wrapped)'>
                <YesNoSelectionPanelGroup
                    id='yesNoHorizontalWrappedDemo'
                    value={horizontalWrappedValue}
                    onChange={set_horizontalWrappedValue}
                    theme={SelectionPanelGroupTheme.Blue}
                    styleMode={SelectionPanelGroupStyleMode.Condensed}
                    checkShape={SelectionPanelCheckShape.Circle}
                    checkStyle={SelectionPanelCheckStyle.Fill}
                    label='First Loan?'
                    showInfoIcon={true}
                    infoText='Is the property owned by the borrower?'
                    layoutStyle={SelectionPanelGroupLayoutStyle.Horizontal}
                    labelWidth='150px'
                    wrapPanels={true}
                />
            </DemoExample>
        </>
    );
};
